import {STROKE_WIDTH_MAP} from './constants';

export const strokeWidth = (size: number): number => {
  const mapped = STROKE_WIDTH_MAP[size];
  if (mapped !== undefined) return mapped;

  const raw = size / 12;
  const snapped = Math.round(raw * 2) / 2;
  return Math.max(1, snapped);
};
